import { call, select, takeLatest } from 'redux-saga/effects';

import { track } from 'analytics/segment';
import getCountryFromLanguage from 'utils/i18n';
import { selectors as authSelectors } from 'state/auth';

import types from 'state/analytics/actionTypes';

import getAnonymousId from './getAnonymousId';

function* handleSendEvent({ payload }) {
  const { eventName, eventData } = payload;
  const user = yield select(authSelectors.getUser);
  const countryFromLang = getCountryFromLanguage();

  try {
    const { id, uuid, country } = user || {};
    const anonymousId = getAnonymousId();
    yield call(track, {
      eventName,
      eventData,
      country: country || countryFromLang,
      userId: uuid || anonymousId,
      anonymousId: anonymousId,
      ontruckUserId: id || anonymousId,
    });
  } catch (err) {
    console.error('ERROR', err);
  }
}

export default function* () {
  yield takeLatest(types.sendEvent$, handleSendEvent);
}

export { getAnonymousId };
